goog.provide("shadow.js.shim.module$$mui$material$CardContent");
goog.provide("module$shadow_js_shim_module$$mui$material$CardContent");
shadow.js.shim.module$$mui$material$CardContent = shadow.js.nativeProvides["@mui/material/CardContent"] = shadow$bridge("@mui/material/CardContent");
module$shadow_js_shim_module$$mui$material$CardContent.default = shadow.js.shim.module$$mui$material$CardContent;
